import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/Reveal";

const IMG = "/assets/metodologia-como-trabajamos.webp";

export const HowWeWork = ({ withImage = true, showHeader = true, showIntro = false }) => {
  const { t } = useLang();
  return (
    <section className="py-14 md:py-20 border-t border-navy/5" data-testid="how-we-work-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20">
        <div className="lg:col-span-5">
          {showHeader && (
            <Reveal>
              <Overline>{t.howWeWork.overline}</Overline>
              <h2 className="font-display text-4xl md:text-5xl leading-[1.08] tracking-tight text-navy mt-4">
                {t.howWeWork.title}
              </h2>
              {showIntro && (
                <p className="mt-6 text-base md:text-lg leading-relaxed text-navy/70">{t.howWeWorkPage.intro}</p>
              )}
            </Reveal>
          )}
          {withImage && (
            <Reveal delay={0.15} className="mt-12 hidden lg:block">
              <img src={IMG} alt={t.howWeWork.imageAlt} loading="lazy" className="w-full aspect-[2/3] object-cover" />
            </Reveal>
          )}
        </div>

        <div className="lg:col-span-7">
          <ol>
            {t.howWeWork.stages.map((s, i) => (
              <Reveal key={s.num} delay={0.06 * i}>
                <li className="flex gap-6 md:gap-10 py-8 border-t border-navy/10 last:border-b" data-testid={`stage-${s.num}`}>
                  <span className="font-display text-5xl md:text-6xl leading-none text-ser-purple/25 shrink-0 w-16 md:w-20" aria-hidden="true">
                    {s.num}
                  </span>
                  <div>
                    <h3 className="font-display text-2xl md:text-3xl text-navy">{s.title}</h3>
                    <p className="mt-2 text-sm md:text-base leading-relaxed text-navy/65 max-w-lg">{s.desc}</p>
                  </div>
                </li>
              </Reveal>
            ))}
          </ol>
          <Reveal delay={0.2}>
            <p className="mt-10 font-display italic text-xl md:text-2xl leading-snug text-navy/85 border-l-2 border-ser-yellow pl-6 max-w-xl">
              {t.howWeWork.closing}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
